import { Container } from 'react-bootstrap';
import Body from '../components/Body';
import HobbyDashboardContainer from '../components/hobbies/HobbyDashboardContainer';

export default function HobbyDashboard() {
  return (
    <Body sidebar>
      <Container fluid className="py-4">
        <HobbyDashboardContainer />
      </Container>
    </Body>
  );
}
